import { ReactElement, useState } from 'react'
import { InputGroup } from '@raskrask-dk/rr-components'
import { useTranslation } from 'react-i18next'
import { PropsCompanyNameFieldTemplate } from './props'
import { nameFieldInputHandler } from '../../../../services/namefield.inputhandler'

const CompanyNameFieldTemplate = ({
    validCompanyName,
    setCompanyName,
    companyName,
    submitClickedWithMissingDetails,
}: PropsCompanyNameFieldTemplate): ReactElement => {
    const { t } = useTranslation()
    const [showError, setShowError] = useState(false)

    const hasError =
        (!validCompanyName && showError) ||
        (submitClickedWithMissingDetails && !validCompanyName)

    return (
        <InputGroup
            data-cy="companyName"
            error={hasError}
            helperText={hasError ? t('details.form.companyname.error') : ''}
            label={t('details.form.companyname.placeholder')}
            onBlur={() => setShowError(true)}
            onChange={(e) =>
                nameFieldInputHandler(e.currentTarget.value, setCompanyName)
            }
            type="text"
            value={companyName}
        />
    )
}

export default CompanyNameFieldTemplate
